<script setup lang="ts">
  import { ref, onMounted, computed } from 'vue';
  import { useGetCookie, useSetCookie } from '@storefront/storefront';
  import { useShared } from '@othercommerce/foundation';

  const shared = useShared();
  const open = ref(false);
  const cookieName = 'dentech_access_professional';
  const name = computed(() => shared.value.appName || 'Promoznawcy');

  function accept() {
    useSetCookie(cookieName, 'true', 180);
    open.value = false;
  }

  onMounted(() => {
    const consent = useGetCookie(cookieName);
    if (!consent) {
      open.value = true;
    }
  });
</script>
<template>
  <UiModal large v-model:open="open">
    <h2>{{ $t('SHOP.MEDICAL.HEADER.WELCOME', { name: name }) }}</h2>
    <p> {{ $t('SHOP.MEDICAL.MESSAGE.PROFESSIONAL_ONLY') }}</p>
    <SfModalFooter>
      <SfButton primary @click="accept">
        {{ $t('SHOP.COMMON.LABEL.IS_PROFESSIONAL') }}
      </SfButton>
      <SfButton>
        {{ $t('SHOP.ACTION.CANCEL') }}
      </SfButton>
    </SfModalFooter>
  </UiModal>
</template>
